// extracted by css-extract-rspack-plugin
export default {"input":"input-Yqn7Ho"};